import {
  BilikPersonInsertInput,
  useBilikPersonFormCreateMutation,
} from 'generated/graphql';
import React, { FunctionComponent, useCallback } from 'react';
import BilikPersonFormCreateContainer from './bilik-person-form-create-container';
import { createKeycloakUser } from 'utils';

const BilikPersonFormCreateRepository: FunctionComponent = () => {
  const [insertBilikPersonOne] = useBilikPersonFormCreateMutation();

  const createBilikPerson = useCallback(
    async (bilikPerson: BilikPersonInsertInput, newPassword: string) => {
      if (!newPassword || !bilikPerson.roleName || !bilikPerson.email) {
        return;
      }

      const groupName =
        bilikPerson.roleName === 'user'
          ? '/bilik-people/managers'
          : '/bilik-people/admins';

      const { id } = await createKeycloakUser({
        email: bilikPerson.email,
        groups: [groupName],
        password: {
          value: newPassword,
          temporary: false,
        },
      });

      const newBilikPerson: BilikPersonInsertInput = {
        ...bilikPerson,
        authUserId: id,
      };

      await insertBilikPersonOne({
        variables: {
          object: newBilikPerson,
        },
      });
    },
    [insertBilikPersonOne],
  );

  return (
    <BilikPersonFormCreateContainer createBilikPerson={createBilikPerson} />
  );
};

export default BilikPersonFormCreateRepository;
